import { module as Module } from 'modujs'
import gsap from 'gsap'
import { html } from '../utils/environment'

export default class extends Module {
  constructor(m) {
    super(m)

    this.titles = this.$('title')
    this.links = this.$('link')
  }

  init() {
    this.timeline()
  }

  timeline() {
    this.menuTimeline = gsap.timeline({ paused: true }).set(this.el, { display: 'flex' })
      .to(this.el, { autoAlpha: 1, duration: 0.5, ease: 'linear' })
      .fromTo(
        this.titles,
        {
          y: '50px',
          autoAlpha: 0,
        },
        {
          y: 0,
          ease: 'power2.out',
          duration: 0.7,
          autoAlpha: 1,
          stagger: 0.1,
        },
      )
      .fromTo(
        this.links,
        {
          y: '30px',
          autoAlpha: 0,
        },
        {
          y: 0, ease: 'power2.out', duration: 0.7, autoAlpha: 1, stagger: 0.1,
        },
        '-=0.4',
      )
  }

  open() {
    html.classList.add('has-menu-open')
    this.menuTimeline.play()
  }

  close() {
    html.classList.remove('has-menu-open')
    this.menuTimeline.reverse()
  }
}
